import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalDay: 0,
    percentTotal: 0
};

export const useAlertN2Store = create((set) => ({

    ...initialState,

    setAlertN2: ({
        data,
        total,
        totalDay,
        percentTotal
    }) => {

        set({
            data,
            total,
            totalDay,
            percentTotal
        });

    },

    clearAlertN2: () => {
        set(initialState);
    }

}));